/**
 * @generated SignedSource<<cb4bdf4dacc3ecae68cfeb8b83a15d51>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteProgramInput = {
  programId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteProgramMutation$variables = {
  input: DeleteProgramInput;
};
export type deleteProgramMutation$data = {
  readonly deleteProgram: {
    readonly deletedProgramId: string | null;
  } | null;
};
export type deleteProgramMutation = {
  variables: deleteProgramMutation$variables;
  response: deleteProgramMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteProgramPayload",
    "kind": "LinkedField",
    "name": "deleteProgram",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedProgramId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteProgramMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteProgramMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8e80a900bea05a67c85932685a1c02c2",
    "id": null,
    "metadata": {},
    "name": "deleteProgramMutation",
    "operationKind": "mutation",
    "text": "mutation deleteProgramMutation(\n  $input: DeleteProgramInput!\n) {\n  deleteProgram(input: $input) {\n    deletedProgramId\n  }\n}\n"
  }
};
})();

(node as any).hash = "51fa0264de5595bcc693195e94beca72";

export default node;
